// Barba.js — page transitions
// Disabilitato nel Theme Editor di Shopify
if (window.Shopify && window.Shopify.designMode) {
  // noop: il Theme Editor gestisce la navigazione internamente
} else {
  const loader = document.querySelector('.barba-loader');

  gsap.set(loader, {
    scaleX: 0,
    rotation: 10,
    xPercent: -5,
    yPercent: -50,
    transformOrigin: 'left center',
    autoAlpha: 1,
    zIndex: 200,
  });

  // ModalDialog e le sue sottoclassi (modal-dialog, product-modal,
  // quick-add-modal, ...) si spostano da sole in document.body nel loro
  // connectedCallback (vedi global.js), uscendo dal container che Barba
  // swappa. Senza questa pulizia restano appese in body dopo il footer ad
  // ogni cambio pagina.
  barba.hooks.beforeLeave(() => {
    document.body.classList.remove('overflow-hidden');
    document.querySelectorAll('body > [data-moved-modal]').forEach((modal) => modal.remove());
  });

  barba.init({
    prevent: ({ el }) => {
      const href = el.getAttribute('href') || '';

      if (el.target === '_blank') return true;
      if (href.startsWith('#')) return true;

      return /^\/(cart|checkout|account|password|cdn|apps|tools)/.test(new URL(href, window.location.origin).pathname);
    },

    transitions: [
      {
        name: 'default-transition',

        leave() {
          // Unico punto di kill: nessun altro modulo crea ScrollTrigger prima
          // che 'page:loaded' venga dispatchato nell'hook globale 'after'.
          ScrollTrigger.getAll().forEach((st) => st.kill());

          return gsap.to(loader, {
            duration: 0.8,
            xPercent: 0,
            scaleX: 1,
            rotation: 0,
            ease: 'power4.inOut',
          });
        },

        after() {
          if (window.lenis) window.lenis.scrollTo(0, { immediate: true });

          const videos = document.querySelectorAll('video');
          videos.forEach((video) => video.play());

          return gsap.to(loader, {
            duration: 0.8,
            scaleX: 0,
            xPercent: 5,
            rotation: -10,
            transformOrigin: 'right center',
            ease: 'power4.inOut',
            onComplete: () => {
              gsap.set(loader, {
                scaleX: 0,
                rotation: 10,
                xPercent: -5,
                yPercent: -50,
                transformOrigin: 'left center',
                autoAlpha: 1,
                zIndex: 200,
              });
            },
          });
        },
      },
    ],
  });

  // Tutti gli script delle sezioni sono caricati nell'<head> di theme.liquid.
  // I Custom Element sono quindi già definiti quando Barba swappa il container:
  // gli elementi si connettono al DOM e constructor/connectedCallback partono
  // automaticamente senza bisogno di ri-eseguire nulla.
  //
  // Questo hook gestisce solo i CSS (che restano per-sezione) e pulisce i
  // tag <script> dal container per evitare NotSupportedError da doppia define.
  barba.hooks.beforeEnter(({ next }) => {
    const headStyles = new Set([...document.head.querySelectorAll('link[rel="stylesheet"][href]')].map((l) => l.href));
    const pendingStyles = [];

    // Sposta stylesheet del container nel <head> prima dello swap.
    // Se lasciati nel container, sparirebbero dal DOM quando il vecchio
    // container viene rimosso → FOUC.
    next.container.querySelectorAll('link[rel="stylesheet"][href]').forEach((link) => {
      if (!headStyles.has(link.href)) {
        const newLink = document.createElement('link');
        [...link.attributes].forEach((attr) => newLink.setAttribute(attr.name, attr.value));

        // Aspetta che il CSS sia applicato: senza questa attesa afterEnter
        // (e quindi initDarkNav) misura il layout prima che gli stili del
        // nuovo container siano caricati, calcolando posizioni sbagliate.
        pendingStyles.push(
          new Promise((resolve) => {
            newLink.addEventListener('load', resolve, { once: true });
            newLink.addEventListener('error', resolve, { once: true });
          }),
        );

        document.head.appendChild(newLink);
        headStyles.add(link.href);
      }
    });

    // Rimuove tutti i <script src> dal container — sono già in head.
    // Evita customElements.define() duplicati che causano NotSupportedError.
    next.container.querySelectorAll('script[src]').forEach((s) => s.remove());
    next.container.querySelectorAll('link[rel="stylesheet"]').forEach((l) => l.remove());

    return Promise.all(pendingStyles);
  });

  barba.hooks.afterEnter(({ next }) => {
    // Ri-esegue gli script inline nel container (es. dati JSON-LD esclusi,
    // variabili page-specific come prezzi, ID prodotto, ecc.)
    next.container.querySelectorAll('script:not([src])').forEach((script) => {
      const type = script.getAttribute('type') || '';
      if (type && type !== 'text/javascript') return;

      const newScript = document.createElement('script');
      newScript.textContent = script.textContent;
      script.replaceWith(newScript);
    });

    // Iubenda scansiona il DOM una sola volta, al caricamento dello script.
    // Le pagine con testo di privacy/cookie policy (link "iubenda-embed")
    // raggiunte via Barba arrivano dopo quella scansione iniziale, quindi
    // vanno riprocessate ricaricando iubenda.js — è lo stesso meccanismo
    // dello snippet ufficiale iubenda per contenuti aggiunti dinamicamente.
    if (next.container.querySelector('.iubenda-embed, .iubenda-a')) {
      const iubendaScript = document.createElement('script');
      iubendaScript.src = 'https://cdn.iubenda.com/iubenda.js';
      document.body.appendChild(iubendaScript);
    }
  });

  // Il container della pagina precedente viene rimosso da Barba subito prima
  // dell'hook globale 'after' (dopo afterEnter). Dispatchare 'page:loaded' qui
  // — e non in afterEnter — garantisce che dark-nav/custom-hero misurino il
  // DOM quando è rimasto presente solo il container della nuova pagina.
  barba.hooks.after(({ next }) => {
    document.dispatchEvent(new CustomEvent('page:loaded', { detail: next }));

    if (typeof ScrollTrigger !== 'undefined') {
      ScrollTrigger.refresh();
    }
  });
}
